const DEV_LIKE_HOSTS = new Set([
  'localhost',
  '127.0.0.1',
  'dev-app.treegress.com',
  'sandbox-app.treegress.com',
])

const PRODUCTION_PROTOTYPES_ALLOWED_EMAILS = new Set([
  'a.tarapatov+7@mobidev.biz',
])

const getHost = () => {
  if (typeof window === 'undefined') return ''
  return String(window.location?.hostname || '').toLowerCase()
}

const isRuntimeDevLikeHost = () => DEV_LIKE_HOSTS.has(getHost())

const normalizeEmail = (email) => String(email || '').trim().toLowerCase()

const isAllowedProductionUser = (email) =>
  PRODUCTION_PROTOTYPES_ALLOWED_EMAILS.has(normalizeEmail(email))

const isPrototypesEnabled = (email) => {
  if (isRuntimeDevLikeHost()) return true
  return isAllowedProductionUser(email)
}

export default isPrototypesEnabled
